import{a as r}from"./chunk-EI7MMDWY.js";var n=r(()=>Math.round(Math.random()),"zeroOrOne");export{n as a};
